import { Injectable } from '@angular/core';
import { StoreItem } from './StoreItem';
import { OrderProcessData } from '../../jurisdiction-overview/jurisdiction-overview.domain';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrderProcesStore {
  constructor() {}

  private _orderProcessData: StoreItem<OrderProcessData> = new StoreItem<OrderProcessData>(null);

  public setOrderProcessData(value: OrderProcessData) {
    this._orderProcessData.setValue(value);
  }

  public getOrderProcessValue(): Observable<OrderProcessData> {
    return this._orderProcessData.getObservable();
  }
}
